
import { Fragment } from 'react';
import { FovTypography, HorizontalSpacer } from 'components';
import { UserOutlined, LampOutlined } from 'components/icons';
import { IconButton } from './styles';
import { NameContainer, TableThumbnail } from 'pages/ArchVisionAdminDashboard/styles';


export const modelListColumns = () => ([
    {
        title: 'Thumbnail',
        key: 'thumbnail',
        width: 110,
        alignContent: 'center',
        render: (text, model) => {
            const { previewURL, preview256URL, preview512URL } = model;
            return (
                <TableThumbnail src={preview256URL || preview512URL || previewURL} />
            );
        },
    },
    {
        title: 'Title',
        key: 'title',
        width: 300,
        alignContent: 'left',
        render: (text, model) => (
            <NameContainer>
                <div>{model.title}</div>
            </NameContainer>
        ),
    },
    {
        title: 'Category',
        key: 'category',
        width: 120,
        render: (text, model) => (
            <NameContainer>
                <FovTypography fontSize={16}>{model.category}</FovTypography>
                {model.subcategory && <FovTypography fontSize={12}>└ {model.subcategory}</FovTypography>}
            </NameContainer>
        ),
    },
    {
        title: 'Creator',
        key: 'creator',
        width: 125,
        render: (text, model) => {
            return model.creator
                ? <FovTypography>{model.creator}</FovTypography>
                : '';
        },
    },
]);

export const listColumns = (theme, selectedTheme, setSelectedCreator) => ([
    {
        title: 'Creator Name',
        key: 'name',
        width: 300,
        alignContent: 'left',
        render: (text, creator) => {
            return (
                <NameContainer>
                    <div>{creator.display_name}</div>
                    <FovTypography fontSize={12}>({creator.creator_id})</FovTypography>
                </NameContainer>
            );
        },
    },
    {
        title: 'Model Count',
        key: 'modelCount',
        width: 100,
        render: (text, creator) => (
            <Fragment>
                <LampOutlined />
                <HorizontalSpacer size={5} />
                {creator.modelCount}
            </Fragment>
        ),
    },
    {
        title: 'Product IDs',
        key: 'subscriptions',
        width: 120,
        render: (text, creator) => (
            <NameContainer>
                {
                    creator.month_product_id && creator.month_product_id !== -1 &&
                    <FovTypography fontSize={12}>{creator.month_product_id} (Month)</FovTypography>
                }
                {
                    creator.year_product_id && creator.year_product_id !== -1 &&
                    <FovTypography fontSize={12}>{creator.year_product_id} (Year)</FovTypography>
                }
            </NameContainer>
        ),
    },
    {
        title: 'Profile',
        key: 'profile',
        render: (text, creator) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => {
                    setSelectedCreator(creator);
                }}
                icon={<UserOutlined title='Access creator profile'/>}

            />
        ),
    },
]);